(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medicine', {
            parent: 'entity',
            url: '/medicine?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medicine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicine/medicines.html',
                    controller: 'MedicineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medicine-detail', {
            parent: 'entity',
            url: '/medicine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medicine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medicine/medicine-detail.html',
                    controller: 'MedicineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medicine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Medicine', function($stateParams, Medicine) {
                    return Medicine.get({id : $stateParams.id});
                }]
            }
        })
        .state('medicine.new', {
            parent: 'medicine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-dialog.html',
                    controller: 'MedicineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                barcode: null,
                                pairCode: null,
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('medicine');
                });
            }]
        })
        .state('medicine.edit', {
            parent: 'medicine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-dialog.html',
                    controller: 'MedicineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medicine', function(Medicine) {
                            return Medicine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medicine.delete', {
            parent: 'medicine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medicine/medicine-delete-dialog.html',
                    controller: 'MedicineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medicine', function(Medicine) {
                            return Medicine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('medicine', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
